import { CREATE_ADS, CREATE_ADS_FAILURE, CREATE_ADS_SUCCESS, DELETE_ADS, DELETE_ADS_FAILURE, DELETE_ADS_SUCCESS, EDIT_ADS, EDIT_ADS_FAILURE, EDIT_ADS_SUCCESS, GET_ADS_LISTING, GET_ADS_LISTING_FAILURE, GET_ADS_LISTING_SUCCESS } from "../constants";

export default class AdsAction {
    static getAdsListing(payload, cb) {
        return {
            type: GET_ADS_LISTING,
            payload,
            cb,
        };
    }
    static getAdsListingSuccess(payload) {
        return {
            type: GET_ADS_LISTING_SUCCESS,
            payload,
        };
    }
    static getAdsListingFailure() {
        return {
            type: GET_ADS_LISTING_FAILURE,
        };
    }
    static deleteAds(id, cb) {
        return {
            type: DELETE_ADS,
            id,
            cb,
        };
    }
    static deleteAdsSuccess(payload) {
        return {
            type: DELETE_ADS_SUCCESS,
            payload,
        };
    }
    static deleteAdsFailure() {
        return {
            type: DELETE_ADS_FAILURE,
        };
    }

    static editAds(data, cb) {
        return {
            type: EDIT_ADS,
            data,
            cb,
        };
    }

    static editAdsSuccess(payload) {
        return {
            type: EDIT_ADS_SUCCESS,
            payload,
        };
    }

    static editAdsFailure() {
        return {
            type: EDIT_ADS_FAILURE,
        };
    }

    static createAds(data, cb) {
        return {
            type: CREATE_ADS,
            data,
            cb,
        };
    }

    static createAdsSuccess(payload) {
        return {
            type: CREATE_ADS_SUCCESS,
            payload,
        };
    }

    static createAdsFailure() {
        return {
            type: CREATE_ADS_FAILURE,
        };
    }
}

